<template>
    <div
        class="my-auto w-100 main-area"
        style="padding-top: 25px; margin-top: 10px !important; box-shadow:none; background:white; border-radius:0px"
        >
        <div class="site-title-custom row full justify-content-center">
            <p>
                <a href="https://www.blm.co.jp/privacy.html" target="_blank">
                    プライバシーポリシー
                </a>
            </p>
            <p>
                <a href="https://www.blm.co.jp/security.html" target="_blank">
                  情報セキュリティ基本方針
                </a>
            </p>
        </div>
        <div class="" style="text-align:center">
            <a href="https://www.blm.co.jp/" target="_blank" style="color:#232323">© Bloom Inc.</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
    .full a{
        color: black;
    }
    .full{
        gap:100px;
    }
   @media (max-width:550px){
    .full{
        gap:40px;
    }
   }
</style>
